module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [(!_vm.hasLoaded) ? _c('md-layout', {
    attrs: {
      "md-flex": ""
    }
  }, [_c('md-progress', {
    attrs: {
      "md-indeterminate": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-body-1"
  }, [_vm._v("Carregando dados da aplicação...")])], 1) : _vm._e(), _vm._v(" "), _c('check-requisites', {
    on: {
      "onRequisitesCheck": _vm.onRequisitesCheck
    }
  }), _vm._v(" "), (_vm.meetRequisites) ? _c('div', [(!_vm.blh) ? _c('md-layout', {
    staticClass: "start-process",
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("Selecione o BLH antes de prosseguir")]), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "select-userBlhs"
    }
  }, [_vm._v("Banco de Leite Humano")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "select-userBlhs",
      "id": "select-userBlhs"
    },
    model: {
      value: (_vm.selectedBLH),
      callback: function($$v) {
        _vm.selectedBLH = $$v
      },
      expression: "selectedBLH"
    }
  }, _vm._l((_vm.userBlhs), function(blh, index) {
    return _c('md-option', {
      key: blh.id,
      attrs: {
        "value": index
      }
    }, [_vm._v(_vm._s(blh.name))])
  }), 1)], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary md-raised",
    on: {
      "click": _vm.setActiveBLH
    }
  }, [_vm._v("PROSSEGUIR")])], 1) : (!_vm.certificationProcess && _vm.blh) ? _c('md-layout', {
    staticClass: "start-process",
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("Olá "), _c('b', [_vm._v(_vm._s(_vm.blh.name))]), _vm._v(", seja bem vindo ao")]), _vm._v(" "), _c('span', {
    staticClass: "md-title"
  }, [_vm._v("PROCESSO DE CERTIFICAÇÃO " + _vm._s(_vm.blh.currentYear))]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("Antes de iniciar o processo, veja atentamente as instruções abaixo")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("Atenção: lembre-se de reunir a planta e as informaçoes necessárias do " + _vm._s(_vm.blh.name))]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": function($event) {
        return _vm.startCertificationProcess()
      }
    }
  }, [_vm._v("INICIAR PROCESSO DE CERTIFICAÇÃO")])], 1) : _c('md-layout', [_c('md-tabs', {
    ref: "tabs",
    staticClass: "md-transparent",
    attrs: {
      "md-centered": "",
      "md-fixed": ""
    },
    on: {
      "change": _vm.changeHandler
    }
  }, [_c('md-tab', {
    ref: "tabAreas",
    attrs: {
      "md-label": "INSTALAÇÕES",
      "md-icon": "layers",
      "md-active": _vm.isAreaActive,
      "md-disabled": _vm.certificationProcess.status >= 6
    }
  }, [_c('area-definitions')], 1), _vm._v(" "), _c('md-tab', {
    ref: "tabFotos",
    attrs: {
      "md-label": "Fotos",
      "md-icon": "camera_alt",
      "md-disabled": _vm.certificationProcess.status < 4 || _vm.certificationProcess.status >= 6,
      "md-active": _vm.isPhotoActive
    }
  }, [(_vm.isPhotoActive) ? _c('photos-list') : _vm._e()], 1), _vm._v(" "), _c('md-tab', {
    ref: "tabReview",
    attrs: {
      "md-label": "Revisão",
      "md-icon": "visibility",
      "md-disabled": _vm.certificationProcess.status < 5 || _vm.certificationProcess.status >= 6,
      "md-active": _vm.isReviewActive
    }
  }, [_c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('span', [_c('p', [_vm._v("Muito bem! Você preencheu todos as informações, agora é o momento de revisar, fique à vontade, verifique todas as informações e assim que estiver tudo pronto, clique no botão abaixo.")]), _vm._v(" "), _c('p', [_vm._v("IMPORTANTE! Após esta etapa não será possível alterar os dados da certificação")])]), _vm._v(" "), _c('md-button', {
    staticClass: "md-accent md-raised",
    on: {
      "click": function($event) {
        return _vm.startSync()
      }
    }
  }, [_vm._v("SUBMETER DADOS DE CERTIFICAÇÃO")])], 1)], 1), _vm._v(" "), _c('md-tab', {
    ref: "tabSyncronization",
    attrs: {
      "md-label": "Submeter",
      "md-icon": "backup",
      "md-disabled": _vm.certificationProcess.status < 6,
      "md-active": _vm.isSubmitActive
    }
  }, [(_vm.isSubmitActive) ? _c('sync-queue') : _vm._e()], 1)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e5b07000","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/HomeView.vue
// module id = 843
// module chunks = 1